import { render, staticRenderFns } from "./KeyGuestsTab.vue?vue&type=template&id=1678fa78&"
import script from "./KeyGuestsTab.vue?vue&type=script&lang=ts&"
export * from "./KeyGuestsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports